var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "80%" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "ma-0 pa-0" },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-1",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "py-0" },
            [
              _c("v-text-field", {
                staticClass: "ma-0 pa-0",
                attrs: { label: "Test Name", outlined: "" },
                model: {
                  value: _vm.aBtest.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.aBtest, "name", $$v)
                  },
                  expression: "aBtest.name",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "py-0" },
            [
              _c("v-textarea", {
                attrs: { outlined: "", label: "Message" },
                model: {
                  value: _vm.aBtest.message,
                  callback: function ($$v) {
                    _vm.$set(_vm.aBtest, "message", $$v)
                  },
                  expression: "aBtest.message",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0 mb-3" },
            [
              _c("v-card-text", { staticClass: "grey--text ma-0 pa-0 ml-4" }, [
                _vm._v("Audiences"),
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "mr-0",
                  attrs: { color: "green", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.addAudience()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-plus")])],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "mr-4",
                  attrs: { color: "red", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.removeAudience()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-minus")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "py-0 mb-10" },
            [
              _c(
                "v-card",
                {
                  staticStyle: { display: "flex" },
                  attrs: { width: "100%", elevation: "0" },
                },
                [
                  _c(
                    "v-card-actions",
                    {
                      staticClass: "ma-0 pa-0",
                      staticStyle: { width: "100%" },
                    },
                    [
                      _c(
                        "SplitGrid",
                        _vm._b(
                          {
                            staticClass: "sb_sub-grid",
                            style: {
                              "margin-right":
                                (_vm.aBtest.audiences.length - 1) * 5 + "px",
                            },
                            attrs: { strictMode: false },
                            on: { drag: _vm.onDrag },
                          },
                          "SplitGrid",
                          _vm.splitGridOptions,
                          false
                        ),
                        [
                          _vm._l(_vm.audiences, function (audience, index) {
                            return [
                              _c(
                                "SplitGridArea",
                                {
                                  key: audience.name,
                                  attrs: {
                                    "size-unit": "%",
                                    "size-value": audience.percent,
                                  },
                                },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      attrs: {
                                        elevation: "0",
                                        color: audience.getColor(),
                                      },
                                    },
                                    [
                                      _c(
                                        "v-card-actions",
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              staticStyle: { color: "white" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  audience.name.toUpperCase()
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "h4",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              staticStyle: { color: "white" },
                                            },
                                            [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    Math.round(audience.percent)
                                                  ) +
                                                  ")%"
                                              ),
                                            ]
                                          ),
                                          _c("v-spacer"),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("SplitGridGutter", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      index != _vm.aBtest.audiences.length - 1,
                                    expression:
                                      "index != aBtest.audiences.length - 1",
                                  },
                                ],
                                key: audience.name + "s",
                                staticStyle: {
                                  "background-color": "grey",
                                  margin: "1px",
                                },
                              }),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "py-0" },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Users (0 - all)",
                  type: "number",
                  outlined: "",
                  dense: "",
                  rules: [_vm.rules.value],
                },
                model: {
                  value: _vm.aBtest.users,
                  callback: function ($$v) {
                    _vm.$set(_vm.aBtest, "users", $$v)
                  },
                  expression: "aBtest.users",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { loading: _vm.buttonLoading, color: "primary" },
                  on: { click: _vm.onPressSave },
                },
                [_vm._v("SAVE ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }